import LocalizedStrings from 'react-localization';

export let strings = new LocalizedStrings({
    en: {
        heading: 'New subject',
        headingUpdate: 'Update subject',
        paragraph: 'Name this subject',
        button: {
            text: 'Create subject',
            textUpdate: 'Update subject'
        }
    },
    es: {
        heading: 'Nuevo tema de conversación',
        headingUpdate: 'Actualiza el tema de conversación',
        paragraph: 'Dale un nombre a este tema de conversación',
        button: {
            text: 'Crear tema de conversación',
            textUpdate: 'Actualizar'
        }
    }
});


// WEBPACK FOOTER //
// ./src/redux/components/organisms/FormCreateSubject/FormCreateSubjectContent.js